
export function googleMaps(mapStyle, zoomLevel, fullScreen) {
  if (typeof google !== 'object' && typeof google.maps !== 'object') {
    return;
  }
  const mapEl = $('#google-map');
  const markers = [{
    lat: parseFloat(mapEl.closest('.map-container').data('latitude')),
    lng: parseFloat(mapEl.closest('.map-container').data('longitude'))
  }];

  if (mapEl.length > 0) {
    const latlngbounds = new google.maps.LatLngBounds();
    const mapPrperties = {
      mapTypeId: $('.map-render-param').data('maptype'),
      zoomControl: parseFloat($('.map-render-param').data('enablezoomcontrol')),
      mapTypeControl: parseFloat($('.map-render-param').data('enablemaptypecontrol')),
      scaleControl: parseFloat($('.map-render-param').data('enablescalecontrol')),
      streetViewControl: parseFloat($('.map-render-param').data('enablestreetviewcontrol')),
      rotateControl: parseFloat($('.map-render-param').data('enablerotatecontrol')),
      centerMapControl: parseFloat($('.map-render-param').data('enablecentermapcontrol'))
    };
    if ($('.map-render-param').data('zoomlevel')) {
      zoomLevel = $('.map-render-param').data('zoomlevel');
    }
    const map = new google.maps.Map(document.getElementById('google-map'), {
      zoom: zoomLevel,
      center: new google.maps.LatLng(markers[0].lat, markers[0].lng),
      zoomControl: mapPrperties.zoomControl,
      mapTypeId: mapPrperties.mapTypeId,
      mapTypeControl: mapPrperties.mapTypeControl,
      scaleControl: mapPrperties.scaleControl,
      streetViewControl: mapPrperties.streetViewControl,
      rotateControl: mapPrperties.rotateControl,
      centerMapControl: mapPrperties.centerMapControl,
      styles: mapStyle,
      fullscreenControl: fullScreen,
    });
    if ($('#locationdetail').html() !== '') {
      let marker = new google.maps.Marker({
        map
      });
      for (let i = 0; i < markers.length; i++) {
        const markerData = markers[i];
        const myLatlng = new google.maps.LatLng(markerData.lat, markerData.lng);
        marker = new google.maps.Marker({
          position: myLatlng,
          map,
          title: markerData.title,
          draggable: false,
          animation: google.maps.Animation.DROP
        });
        const infowindow = new google.maps.InfoWindow({
          content: $('#locationdetail').html()
        });
        google.maps.event.addListener(marker, 'click', () => {
          infowindow.open(map, marker);
        });
        latlngbounds.extend(marker.position);
      }
    }
  }
}
